import React from 'react'
import { Modal } from 'antd'
import { TableRowEditButton } from 'components/elements/AppButton'
import {SnapList} from 'components/elements/ListEditor'
import {withRouter} from 'react-router-dom'

class AppointmentTypeCards extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick() {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Delete Item',
      content: 'Are you sure to delete this item?',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }
  

  render() {
    return (
      <SnapList
        data={this.props.dataSource || []}
        listType={'Appointment Type'}
        sortBy={'name'}
        createPrompt={'Create New Appointment Type'}
        initial={this.props.match.params.id}
        onSelect={this.props.onSelect}
        onCreate={this.props.onCreate}
        row={(props)=>(
          <div>
            {props.name}
          </div>
        )}
      />
    )
  }
}

export default withRouter(AppointmentTypeCards)